import React, {FC, useEffect, useState} from "react"

import PaymentForm from "@irati-web/payments/src/components/PaymentForm"
import PaymentFormV2 from "@irati-web/payments/src/components/PaymentFormV2"
import {PaymentMethodKind, Topup} from "@irati/types"
import Loading from "@irati/ui/src/Loading"
import tracking from "@irati-tracking/wallet/rewardPointsWallet"
import authentication from "@irati/auth"
import {useIsCheckoutDotcomEnabledQuery} from "@irati/payments/hooks"
import {getDomain} from "@irati/utils/links"

interface Props {
  finalCost: number
  rewardWalletTopup: Topup
  getTopupStatus: () => void
  getPaymentRedirectUrl: () => void
  createTopUp: () => Promise<void>
}

const PayByCard: FC<Props> = ({rewardWalletTopup, getTopupStatus, getPaymentRedirectUrl, createTopUp, finalCost}) => {
  const [load, setLoad] = useState<Promise<any>>()
  const {data: isCheckoutDotComEnabled, load: checkoutEnabledLoad} = useIsCheckoutDotcomEnabledQuery(null, {
    fetchPolicy: "cache-and-network"
  })

  useEffect(() => {
    const req = createTopUp()
    setLoad(req)
    tracking.payByCard(authentication.apps("wallet.flexiRewards.canTopUpRewardPoints") ? "Admin" : "Manager")
  }, [])

  const domain = getDomain(authentication.business().subdomain)
  const checkoutReturnUrl = `${domain}/wallet/flexi-checkout-complete/${rewardWalletTopup.uuid}`

  return (
    <Loading load={load} initLoad>
      <Loading load={checkoutEnabledLoad} initLoad>
        {isCheckoutDotComEnabled ? (
          <PaymentFormV2
            paymentOrderId={rewardWalletTopup?.paymentOrder?.uuid}
            amount={finalCost}
            currency={rewardWalletTopup?.paymentOrder?.currency}
            onComplete={getTopupStatus}
            returnUrl={checkoutReturnUrl}
            hiddenPaymentMethods={[PaymentMethodKind.PayPal]}
          />
        ) : (
          <PaymentForm
            paymentOrder={rewardWalletTopup?.paymentOrder}
            amount={finalCost}
            onComplete={getTopupStatus}
            redirectReturnUrl={getPaymentRedirectUrl}
          />
        )}
      </Loading>
    </Loading>
  )
}

export default PayByCard
